<h1 mat-dialog-title>
  <b *ngIf="data.selection?.count > 0">{{ 'ALDEN.DIALOGS.DOWNLOAD_ALL_DOCUMENTS.SELECTED_TITLE' | translate }}</b>
  <b *ngIf="data.selection?.count == 0">{{ 'ALDEN.DIALOGS.DOWNLOAD_ALL_DOCUMENTS.ALL_TITLE' | translate }}</b>
</h1>
<mat-dialog-content>
  <div class="custom-mat-dialog-content">
    <mat-icon *ngIf="data.selection?.count == 0" class="custom-mat-icon" color="warn">warning</mat-icon>
    <span *ngIf="data.selection?.count == 1"><b>{{ 'ALDEN.DIALOGS.DOWNLOAD_ALL_DOCUMENTS.SELECTED_ONE' | translate: { count: data.selection?.count } }}</b></span>
    <span *ngIf="data.selection?.count > 1"><b>{{ 'ALDEN.DIALOGS.DOWNLOAD_ALL_DOCUMENTS.SELECTED_MANY' | translate: { count: data.selection?.count } }}</b></span>
    <span *ngIf="data.selection?.count > 0"><i>{{ 'ALDEN.DIALOGS.DOWNLOAD_ALL_DOCUMENTS.SELECTED_ONLY' | translate }}</i></span>
    <span *ngIf="data.selection?.count == 0">{{ 'ALDEN.DIALOGS.DOWNLOAD_ALL_DOCUMENTS.NO_SELECTION' | translate }} <br><b><i>{{ 'ALDEN.DIALOGS.DOWNLOAD_ALL_DOCUMENTS.ALL_DOCUMENTS' | translate: { total: data.nodeIds?.length || 0 } }}</i></b></span>
    <br />
    <span>{{ 'ALDEN.DIALOGS.DOWNLOAD_ALL_DOCUMENTS.CONFIRM' | translate }}</span>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="accent" mat-dialog-close>
    {{ 'ALDEN.DIALOGS.DOWNLOAD_ALL_DOCUMENTS.CANCEL' | translate }}
  </button>
  <button
    mat-raised-button color="primary"
    (click)="download()"
  >
    {{ 'ALDEN.DIALOGS.DOWNLOAD_ALL_DOCUMENTS.DOWNLOAD' | translate }}
  </button>
</mat-dialog-actions>

